import React from 'react';
import { connect } from 'react-redux';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { getFileStatusColumnHtml } from '../../common/ApplicationFunctions';
import { PropertyStatusTypeOptions } from '../../common/ApplicationConstants';
import { ApplActionsButton } from '../../common/ApplicationComponents';
import { onCellDblClickAppraisalOrder } from '../../common/ApplicationFunctions';

const BfiToOrderPortfolioTable = ({ data, isRental = false, isBridge = false }) => {
    const actionCellRender = (e) => {
        return (
            <ApplActionsButton
                data={e.data}
                isPropertyLevel={true}
                parentElementId='toOrderPortfolio'
            />
        );
    };

    const onAddressCellRender = (e) => {
        if (e.data.address.street2) {
            return e.data.address.street1 + ', ' + e.data.address.street2;
        } else {
            return e.data.address.street1;
        }
    };

    const onStatusIdRender = (e) => {
        const statusType = PropertyStatusTypeOptions.find((a) => a.id === e.data.propertyStatusId);
        return statusType?.shortName;
    };

    const onFileStatusCellRender = (e) => {
        return getFileStatusColumnHtml(e.value);
    };

    const onCellPrepared = (e) => {
        if (e.rowType !== 'data') {
            return;
        }

        if (!e.data.disabled) {
            e.cellElement.id = null;
        } else {
            e.cellElement.className = 'dx_portfolio_inactive';
        }
    };

    if (!data || data.length === 0) {
        return '';
    }

    return (
        <DataGrid
            dataSource={data}
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={false}
            allowColumnResizing={true}
            width={'80%'}
            cellHintEnabled={true}
            onCellPrepared={onCellPrepared}
            onCellDblClick={onCellDblClickAppraisalOrder}
        >
            <Column
                dataField='propertyStatusId'
                caption='Status'
                width={120}
                cellRender={onStatusIdRender}
                alignment={'left'}
            />
            <Column
                dataField='address.street1'
                caption='Address'
                cellRender={onAddressCellRender}
            />
            <Column
                dataField='address.city'
                caption='City'
                width={150}
            />
            <Column
                dataField='address.state'
                caption='State'
                width={70}
            />
            <Column
                dataField='address.zipCode'
                caption='Zip'
                width={70}
            />
            <Column
                dataField='bfiNumber'
                caption='BFI #'
                dataType='string'
                width={100}
            />
            <Column
                dataField='fileStatusBudget'
                caption='Budget'
                width={70}
                cellRender={(e) => getFileStatusColumnHtml(e.value, isBridge)}
                alignment='center'
                visible={!isRental}
            />
            <Column
                dataField='fileStatusSpecSheet'
                caption='Specs'
                width={70}
                cellRender={(e) => getFileStatusColumnHtml(e.value, isBridge)}
                alignment='center'
                visible={!isRental}
            />
            <Column
                dataField='fileStatusPlans'
                caption='Plan'
                width={70}
                cellRender={(e) => getFileStatusColumnHtml(e.value, isBridge)}
                alignment='center'
                visible={!isRental}
            />
            <Column
                dataField='fileStatusSurvey'
                caption='Survey'
                width={70}
                cellRender={onFileStatusCellRender}
                alignment='center'
                visible={!isRental}
            />
            <Column
                alignment='center'
                cellRender={actionCellRender}
                width={50}
                allowReordering={false}
                allowSorting={false}
                allowResizing={false}
                type='actions'
                fixed={true}
                fixedPosition={'right'}
            />
        </DataGrid>
    );
};

export default BfiToOrderPortfolioTable;
